'use strict';require('../../style/css');
require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/flex/style/css.web.js
// module id = 264
// module chunks = 0